export const getUrlQeury = () => {
  const query = decodeURIComponent(window.location.href).split('?')[1];
  if (!query) {
    return false;
  }
  const queryArr = query.split('&');
  let qeuryObj = {};
  for (let i = 0; i < queryArr.length; i++) {
    let itemArr = queryArr[i].split('=');
    qeuryObj[itemArr[0]] = itemArr[1];
  }
  return qeuryObj;
};

export const makeUrlQueryString = function(obj) {
  var str = [];
  for (var p in obj)
    if (obj.hasOwnProperty(p)) {
      str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
    }
  return str.join("&");
}

export const getSearchQuery = str => {
  if (!str) return '';
  const query = str.split('?')[1];
  if (!query) {
    return false;
  }
  const queryArr = query.split('&');
  let qeuryObj = {};
  for (let i = 0; i < queryArr.length; i++) {
    let itemArr = queryArr[i].split('=');
    qeuryObj[itemArr[0]] = itemArr[1];
  }
  return qeuryObj;
};


// WEBPACK FOOTER //
// ./src/misc/formatUrlquery.js